import ContentEditable from "./textcomplete.contenteditable"

global.Textcomplete || (global.Textcomplete = {})
global.Textcomplete.editors || (global.Textcomplete.editors = {})
global.Textcomplete.editors.ContentEditable = ContentEditable
